import { render, staticRenderFns } from "./BetBar.vue?vue&type=template&id=b9cd679c&"
import script from "./BetBar.vue?vue&type=script&lang=js&"
export * from "./BetBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports